import { Component, Input } from '@angular/core';
import { Rodeo } from '../../../../../model/rodeo';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { RodeoService } from '../../../../../services/rodeo.service';
import { LoadingController, PopoverController, ToastController } from 'ionic-angular';
import { AlertMessager } from '../../../../../lib/alertMessager';
import { AccountHelper } from '../../../../../lib/accountHelper';
import { RodeoEventRun } from '../../../../../model/rodeoEventRun';
import { StockGroup } from '../../../../../model/stock-group';
import { Livestock } from '../../../../../model/livestock';
import { StockService } from '../../../../../services/stock.service';
import { StockGroupPromptPage } from './stock-group-prompt';
import { StockPromptPage } from './stock-prompt';

@Component({
    selector: 'staff-stock',
    templateUrl: 'stock.component.html'
})
export class StockSection {
    @Input() set rodeo(rodeo: Rodeo) {
        this._rodeo = rodeo;
        this.setDisplays();
        this.filterResults();
    }

    get rodeo() {
        return this._rodeo;
    }

    _rodeo: Rodeo;

    stockRunMap: Map<number, RodeoEventRun[]>;
    stockContractors
    filterName: string;
    stockResults: any[] = [];

    accountHelper: AccountHelper = AccountHelper.instance();

    popoverActive: boolean = false;

    constructor(private rodeoService: RodeoService, private loadingControl: LoadingController, private toast: ToastController
        , private alert: AlertMessager, private stockService: StockService, private popoverController: PopoverController) {

    }

    filterResults() {
        this.stockResults = this.rodeo.stockGroups.flatMap(x => x.livestock);

        if (this.filterName && this.filterName.length != 0)
            this.stockResults = this.stockResults.filter(x => x.name.toLowerCase().indexOf(this.filterName.toLowerCase()) != -1);
    }

    addNewStockGroup() {
        this.editStockGroup(new StockGroup());
    }

    editStockGroup(stockGroup: StockGroup) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(StockGroupPromptPage,{
            rodeo: this._rodeo
        }, {
            cssClass: 'stock-group-prompt'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            if (data) {
            }

            this.popoverActive = false;
        });

        if (!this.rodeo.stockGroups)
            this.rodeo.stockGroups = [];
    }

    addNewStock(stockGroup: StockGroup) {
        if (!stockGroup.livestock)
            stockGroup.livestock = [];

        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(StockPromptPage,{
            rodeo: this._rodeo,
            stockGroup: stockGroup
        }, {
            cssClass: 'stock-prompt'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            if (data) {
            }

            this.popoverActive = false;
        });
    }

    removeStock(stockGroupId: number, livestock: Livestock) {
        if (this.popoverActive)
            return;

        let loading = this.loadingControl.create({
            content: 'Removing stock...',
        });

        loading.present();

        this.stockService.deleteLivestock(stockGroupId, [livestock])
        .then(data => {
            loading.dismiss();
            var stockGroup = this.rodeo.stockGroups.filter(x => x.id == stockGroupId)[0];

            if (stockGroup)
                stockGroup.livestock = stockGroup.livestock.filter(x => x.id != livestock.id);

            this.popoverActive = false;
            this.toast.create({
                message: "Stock removed!",
                duration: 3000,
                position: 'middle',
            }).present();
        }, error => {
            loading.dismiss();
            this.alert.showError("Stock Remove Error", error);
            this.popoverActive = false;
        });
    }

    private setDisplays() {
        if (!this.stockRunMap)
            this.stockRunMap = new Map<number, RodeoEventRun[]>();

        var allRuns = this.rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs);
        var allStock = this.rodeo.stockGroups.flatMap(x => x.livestock);

        if (allStock) {
            allStock.forEach(stock => {
                if (stock) {
                    this.stockRunMap.set(stock.id, []);
                    var matchingRuns = allRuns.filter(x => x.livestockId == stock.id);
    
                    matchingRuns.forEach(run => {
                        this.stockRunMap.get(stock.id).push(...matchingRuns);
                    });
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/stock/stock.component.ts